import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/my-work')({
  component: () => <PageStub title="My Work" description="Personal tasks and assignments" />,
});
